export class IntencaoDepositoRequestModel {
    constructor() { }

    public contaId: string;
    public bancoOrigemId: string;
    public valor: number;
}